export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.15-1720.29",
  commitId: "e084a4485f1d414a02c792b164283e70471d64ae",
  commitTime: "2026-04-15T17:20:29.000Z",
});
